import { TEntity } from '@storage/app/models'
import { computed, makeObservable, observable, runInAction } from 'mobx'

export interface EntityStore<T extends TEntity> {
  sorter?(entityA: T, entityB: T): number
}

export abstract class EntityStore<T extends TEntity> {
  public data = new Map<string | number, T>()

  constructor() {
    makeObservable(this, {
      data: observable,

      entries: computed,
    })
  }

  get entries(): T[] {
    let values = Array.from(this.data.values())

    if (this.sorter) {
      values = values.sort(this.sorter)
    }

    return values
  }

  getById(id: string | number): T | undefined {
    return this.data.get(id)
  }

  addOrUpdate(entity: T): void {
    runInAction(() => {
      this.data.set(entity.id, entity)
    })
  }

  setAll(entities: T[]): void {
    runInAction(() => {
      this.data = new Map(entities.map(item => [item.id, item]))
    })
  }

  addOrUpdateMany(entities: T[]): void {
    runInAction(() => {
      entities.forEach(entity => this.addOrUpdate(entity))
    })
  }

  remove(id: string | number): void {
    runInAction(() => {
      this.data.delete(id)
    })
  }

  removeItems(ids: (string | number)[]): void {
    ids.forEach(id => this.remove(id))
  }

  removeAll(): void {
    runInAction(() => {
      this.data = new Map()
    })
  }
}
